<template >
    <page-container2 :title="pageTitle" :useCard="false" showPageBack v-loading="loading">
        <template v-slot:buttons>
            <el-button type="primary" size="mini" @click="toEdit" v-if="!editable">修改统计</el-button>
            <el-button type="success" size="mini" @click="saveBill" v-if="editable">保存修改</el-button>
            <el-button type="info" size="mini" @click="cancelEdit" v-if="editable">取消修改</el-button>
        </template>
        <permission-container showTip permissionId="Erp.BizBillStat.Detail">
        <div class="panel-info">
            <div class="panel-info-name">
                <span class="panel-info-label">账单统计信息</span>
            </div>
            <div class="panel-table">
                <el-row class="panel-table-row">
                    <el-col :span="3"><span class="panel-table-col col-label required">月份：</span></el-col>
                    <el-col :span="3">
                        <div class="panel-table-col col-input">{{ bizBillStat.month }}</div>
                    </el-col>
                    <el-col :span="3"><span class="panel-table-col col-label required">统计周期：</span></el-col>
                    <el-col :span="6">
                        <div class="panel-table-col col-input"><date-render :value="bizBillStat.startDate"/> &nbsp;&nbsp;&nbsp; 至 &nbsp;&nbsp;&nbsp; <date-render :value="bizBillStat.endDate"/></div>
                    </el-col>
                    <el-col :span="3"><span class="panel-table-col col-label required">创建时间：</span></el-col>
                    <el-col :span="6">
                        <div class="panel-table-col col-input">
                            <date-time-render :value="bizBillStat.createTime"/>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="panel-table-row">
                    <el-col :span="3"><span class="panel-table-col col-label required">订单数量：</span></el-col>
                    <el-col :span="3">
                        <div class="panel-table-col col-input">{{ bizBillStat.orderNum }}</div>
                    </el-col>
                    <el-col :span="3"><span class="panel-table-col col-label required">售后单数量：</span></el-col>
                    <el-col :span="6">
                        <div class="panel-table-col col-input">{{ bizBillStat.afterSaleNum }}</div>
                    </el-col>
                    <el-col :span="3"><span class="panel-table-col col-label required">合计金额：</span></el-col>
                    <el-col :span="6">
                        <div class="panel-table-col col-input">
                            <money-render :value="bizBillStat.totalAmount" :precision="2"/>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="panel-table-row">
                    <el-col :span="3"><span class="panel-table-col col-label required">合计重量：</span></el-col>
                    <el-col :span="3">
                        <div class="panel-table-col col-input">{{ bizBillStat.totalWeightNum }}</div>
                    </el-col>
                    <el-col :span="3"><span class="panel-table-col col-label required">合计张数：</span></el-col>
                    <el-col :span="15">
                        <div class="panel-table-col col-input">{{ bizBillStat.totalPicNum }}</div>
                    </el-col>
                </el-row>
            </div>
            
        </div>
        <div class="panel-info">
            <div class="panel-info-name">
                <span class="panel-info-label">订单信息</span>
            </div>
        </div>
        <data-card-table
            cardTableStyle="font-size: 12px; color: #333333;"
            ref="listTable"
            :tableList="orderList"
            :showPage="false"
            :columns="orderColumns">
            <template v-slot:custom-column-customer="slotProps">
                <div>{{slotProps.rowData.customerName}}（{{slotProps.rowData.customerCode}}）</div>
            </template>
            <template v-slot:custom-column-deliverDate="slotProps">
                <date-render :value="slotProps.rowData.deliverDate"/>
            </template>
            <template v-slot:custom-column-productList="slotProps">
                <div v-for="(product, index) in slotProps.rowData.productList" class="order-product-item">
                    <div class="order-product-item-info" style="flex: 4;word-wrap: break-word;">
                        <span>名称：{{product.productName}}</span>
                        <span>编码：{{product.productCode}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <span>{{product.spec}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;width: 110px;word-wrap: break-word;">
                        <span>{{product.customerOrderCode}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <span v-if="product.unitNum">{{product.unitNum}}{{product.unit}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <money-render :value="product.amount" :precision="4"/>
                    </div>
                </div>
            </template>
            <template v-slot:custom-column-creatTime="slotProps">
                <date-time-render :value="slotProps.rowData.createTime"></date-time-render>
            </template>
            <template v-slot:custom-column-buttons="slotProps">
                <el-button
                    size="mini"
                    type="danger"
                    @click="deleteOrder(slotProps.rowData)">删除</el-button>
            </template>
        </data-card-table>

        <div class="panel-info">
            <div class="panel-info-name">
                <span class="panel-info-label">售后单信息</span>
            </div>
        </div>
        <data-card-table
            cardTableStyle="font-size: 12px; color: #333333;"
            ref="listTable1"
            :tableList="afterSaleList"
            :columns="afterSaleColumns">
            <template v-slot:custom-column-customer="slotProps">
                <div>{{slotProps.rowData.customerName}}（{{slotProps.rowData.customerCode}}）</div>
            </template>
            <template v-slot:custom-column-returnDate="slotProps">
                <date-render :value="slotProps.rowData.returnDate"/>
            </template>
            <template v-slot:custom-column-type="slotProps">
                <div>{{ slotProps.rowData.type == 1?'退货':'换货' }}</div>
            </template>
            <template v-slot:custom-column-productList="slotProps">
                <div v-for="(product, index) in slotProps.rowData.productList" class="order-product-item">
                    <div class="order-product-item-info" style="flex: 4;">
                        <span>名称：{{product.productName}}</span>
                        <span>编码：{{product.productCode}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <span>{{product.spec}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <span v-if="product.unitNum">{{product.unitNum}}{{product.unit}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <money-render :value="product.amount" :precision="4"/>
                    </div>
                </div>
            </template>
            <template v-slot:custom-column-creatTime="slotProps">
                <date-time-render :value="slotProps.rowData.createTime"></date-time-render>
            </template>
            <template v-slot:custom-column-buttons="slotProps">
                <el-button
                    size="mini"
                    type="danger"
                    @click="deleteAfterSale(slotProps.rowData)">删除</el-button>
            </template>
        </data-card-table>

        </permission-container>
    </page-container2>
</template>

<script>
import List from "@/components/table/List";
import lodash from 'lodash';
const OrderColumns = [{
                prop: 'customer',
                label: '客户',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;'
            },{
                prop: 'deliveryNumber',
                label: '送货单号',
                span: 2,
                style: 'word-wrap: break-word;'
            },{
                prop: 'carrierCarNumber',
                label: '承运单号',
                span: 2,
                style: 'word-wrap: break-word;'
            },{
                prop: 'deliverDate',
                label: '发货日期',
                span: 2,
            },{
                prop: 'productList',
                label: '产品',
                headerSpan: 4,
                span: 12,
            },{
                prop: 'spec',
                label: '规格',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'customerOrderCode',
                label: '客户单号',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'num',
                label: '数量',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'amount',
                label: '金额',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'createTime',
                label: '创建时间',
                span: 1,
                style: 'text-align: center; width:150px',
            }];
const EditOrderColumns = [{
                prop: 'customer',
                label: '客户',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;'
            },{
                prop: 'deliveryNumber',
                label: '送货单号',
                span: 2,
                style: 'word-wrap: break-word;'
            },{
                prop: 'carrierCarNumber',
                label: '承运单号',
                span: 2,
                style: 'word-wrap: break-word;'
            },{
                prop: 'deliverDate',
                label: '发货日期',
                span: 2,
            },{
                prop: 'productList',
                label: '产品',
                headerSpan: 4,
                span: 12,
            },{
                prop: 'spec',
                label: '规格',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'customerOrderCode',
                label: '客户单号',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'num',
                label: '数量',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'amount',
                label: '金额',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'createTime',
                label: '创建时间',
                span: 1,
                style: 'text-align: center; width:150px',
            },{
                prop: 'buttons',
                label: '操作',
                span: 1,
                style: 'text-align: center; width:140px;line-height: 2.1em;',
            }];
const AfterSaleColumns = [{
                prop: 'customer',
                label: '客户',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;'
            },{
                prop: 'type',
                label: '售后类型',
                headerSpan: 1,
                span: 1,
                style: 'width:80px',
            },{
                prop: 'aftersaleCode',
                label: '退货单号',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;width:160px'
            },{
                prop: 'returnDate',
                label: '退货日期',
                headerSpan: 3,
                span: 2,
            },{
                prop: 'productList',
                label: '产品',
                headerSpan: 4,
                span: 12,
                style: 'word-wrap: break-word;'
            },{
                prop: 'spec',
                label: '规格',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'num',
                label: '数量',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'amount',
                label: '金额',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'createTime',
                label: '创建时间',
                headerSpan: 3,
                span: 3,
                style: 'text-align: center; width:150px',
            }];
const EditAfterSaleColumns = [{
                prop: 'customer',
                label: '客户',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;'
            },{
                prop: 'type',
                label: '售后类型',
                headerSpan: 1,
                span: 1,
                style: 'width:80px',
            },{
                prop: 'aftersaleCode',
                label: '退货单号',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;width:160px'
            },{
                prop: 'returnDate',
                label: '退货日期',
                headerSpan: 3,
                span: 2,
            },{
                prop: 'productList',
                label: '产品',
                headerSpan: 4,
                span: 12,
                style: 'word-wrap: break-word;'
            },{
                prop: 'spec',
                label: '规格',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'num',
                label: '数量',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'amount',
                label: '金额',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'createTime',
                label: '创建时间',
                headerSpan: 3,
                span: 3,
                style: 'text-align: center; width:150px',
            },{
                prop: 'buttons',
                label: '操作',
                span: 1,
                style: 'text-align: center; width:140px;line-height: 2.1em;',
            }];
export default
{
    name: "BizBillStatDetail",
    data()
    {
        return {
            orderList: {
                data: []
            },
            loading: false,
            pageTitle: '账单统计详情',
            bizBillStat: {
                id: null,
                month: null,
                startDate: null,
                endDate: null,
                orderNum:null,
                orderProductNum: null,
                afterSaleNum: null,
                afterSaleProductNum: null,
                totalWeightNum: null,
                totalPicNum: null,
                totalAmount: null,
                createTime: null
            },
            afterSaleList: {
                data: []
            },
            editable: false,
            orderColumns: OrderColumns,
            afterSaleColumns: AfterSaleColumns
        }
    },
    computed: {
        
    },
    created()
    {
    },
    mounted()
    {
        return Fx.Promise.
        then(()=>
        {
            console.log(this.$route.query)
            if(this.$route.query && this.$route.query.id)
            {
                this.bizBillStat.id = this.$route.query.id;
                return this.loadBizBillStat();
            }
        })
    },

    methods:
    {
        toEdit() {
            this.editable = true;
            this.orderColumns = EditOrderColumns;
            this.afterSaleColumns = EditAfterSaleColumns;
        },
        saveBill(){
            this.loading = true;
            let orderIdList = [];
            let afterSaleIdList = [];
            this.orderList.data.forEach(order => {
                orderIdList.push(order.id);
            });
            this.afterSaleList.data.forEach(afterSale => {
                afterSaleIdList.push(afterSale.id)
            })
            console.log(orderIdList, afterSaleIdList);
            return Fx.Http.post("/stats/bizbill/save", {id: this.bizBillStat.id, orderIdList, afterSaleIdList}).
            then((resp)=>
            {
                console.log(resp)
                if(resp.response.code != '0') {
                    this.showMessageError(resp.response.msg);
                }
                return this.loadBizBillStat();
            }).
            then(()=>
            {
                this.loading = false;
                this.editable = false;
                this.orderColumns = OrderColumns;
                this.afterSaleColumns = AfterSaleColumns;
            });
            
        },
        deleteOrder(rowData)
        {
            console.log(rowData);
            const index = this.orderList.data.findIndex(order => rowData.id === order.id);
            if (index > -1) {
                 this.orderList.data.splice(index, 1);
            }
        },
        deleteAfterSale(rowData)
        {
            console.log(rowData);
            const index = this.afterSaleList.data.findIndex(afterSale => rowData.id === afterSale.id);
            if (index > -1) {
                 this.afterSaleList.data.splice(index, 1);
            }
        },
        cancelEdit(){
            this.editable = false;
            this.orderColumns = OrderColumns;
            this.afterSaleColumns = AfterSaleColumns;
            this.loadBizBillStat();
        },
        refresh()
        {
            return Fx.Promise.then(()=>
            {
                return this.$refs.listTable&&this.$refs.listTable.load();
            }).
            then(()=>
            {
                // return this.loadCount();
            });
        },
        loadBizBillStat(){
            this.loading = true;
            return Fx.Http.post("/stats/bizbill/get", {id: this.bizBillStat.id}).
            then((resp)=>
            {
                console.log('bizBillStat:', resp);
                if(resp.isSuccess())
                {
                    this.bizBillStat = Fx.mergeDeep(this.bizBillStat, resp.getData());
                    this.orderList.data = resp.getData('orderList');
                    this.afterSaleList.data = resp.getData('afterSaleList');
                }
            }).
            then(()=>
            {
                this.loading = false;
            });
        }
        
    }
}
</script>

<style scoped lang="scss">
@import "~@/styles/common.scss";
.separator-top
{
    border-top: $border-style;
}
.separator-bottom
{
    border-bottom: $border-style;
}
.order-item-header
{
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    padding-bottom: 5px;
    font-size: 12px;
}
.order-item-footer
{
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    color: #999999;
}
.order-product-item:first-child
{
    border-top: none;
}
.order-product-item
{
    display: flex;
    flex-direction: row;
    padding: 5px 0px;
    border-top: $border-style;
    height: 100%;
}
.order-product-item-info
{
    display: flex;
    flex-direction: column;
    margin-left: 5px;
    justify-content: center;
}
.relate-order-info
{
    padding: 1px 5px;
    margin-left: 3px;
    border-radius: 3px;
    color: #ffffff;
    background-color: rgba(153, 102, 153, 1);
    height: 24px;
}
.relate-order-info.el-link.el-link--default
{
    color: #ffffff;
}

.demo-order
{
    padding: 1px 5px;
    margin-left: 3px;
    border-radius: 3px;
    color: #ffffff;
    background-color: #ff8e02;
}
</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/statement/BizBillStatDetail.vue